import classnames from 'classnames';
import Icon from '@ant-design/icons';
import { Divider } from 'antd';

import { LOCALE } from 'constants/intl-wrapper';
import { META_CATALOG_NAME } from 'constants/pixels';

import BRButton from 'components/BRButton/BRButton';

import { ReactComponent as Done } from 'assets/icons/done.svg';
import { ReactComponent as SllrLogo } from 'assets/icons/SllrLogo.svg';
import { ReactComponent as RepeatIcon } from 'assets/icons/repeat.svg';

import './ConnectionFirstStep.less';

const ConnectionFirstStep = ({
  learnMoreLink,
  learnMoreLinkAr,
  intl,
  name,
  businessInfo,
  icon,
  subIcon,
  iconClassName = ''
}) => {
  const { formatMessage } = intl;
  const { customDomain } = businessInfo?.storeInfo || {};

  const isMetaCatalog = name === META_CATALOG_NAME;

  const CONNECTION_STEPS = [
    {
      id: 1,
      title: (
        <>
          {formatMessage({
            id: `pixels.add_pixel_modal.steps.you_will_need`
          })}
          {formatMessage({
            id: `pixels.add_pixel_modal.steps.${[name]}_step`
          })}
        </>
      )
    },
    ...(isMetaCatalog
      ? [
          {
            id: 2,
            title: formatMessage({
              id: 'pixels.add_pixel_modal.steps.meta_catalog_second_step'
            })
          }
        ]
      : [
          {
            id: 2,
            title: formatMessage(
              {
                id: `pixels.add_pixel_modal.steps.${
                  customDomain
                    ? 'second_step_with_custom_domain'
                    : 'second_step'
                }`
              },
              {
                domain: `https://${customDomain}`,
                link: (
                  <BRButton
                    label={formatMessage({
                      id: `pixels.add_pixel_modal.steps.custom_domain`
                    })}
                    className="button-lg custom-domain-btn"
                    type="link-color"
                    onClick={() =>
                      window.open('/sllr/settings/domains', '_blank')
                    }
                  />
                )
              }
            )
          }
        ]),
    ...(!isMetaCatalog
      ? [
          {
            id: 3,
            title: formatMessage({
              id: 'pixels.add_pixel_modal.steps.last_step'
            })
          }
        ]
      : [])
  ];

  return (
    <>
      <div className="br-add-edit-pixel-id-modal__icons-section">
        <SllrLogo />
        <RepeatIcon />
        <div>
          <Icon
            className={`br-add-edit-pixel-id-modal__app-icon ${iconClassName}`}
            component={icon}
          />
          <Icon
            className={`br-add-edit-pixel-id-modal__app-sub-icon`}
            component={subIcon}
          />
        </div>
      </div>
      <div className="br-add-edit-pixel-id-modal__description body-medium">
        {formatMessage({ id: `pixels.add_pixel_modal.${name}.description` })}
        {!isMetaCatalog && (
          <span
            className="br-add-edit-pixel-id-modal__learn-more"
            onClick={() =>
              window.open(
                intl.locale === LOCALE.EN ? learnMoreLink : learnMoreLinkAr,
                '_blank'
              )
            }
          >
            {formatMessage({ id: `pixels.add_pixel_modal.learn_more` })}
          </span>
        )}
      </div>
      <div className="br-add-edit-pixel-id-modal__steps">
        <div className="br-add-edit-pixel-id-modal__steps__title text-gray subheading">
          {formatMessage({ id: `pixels.add_pixel_modal.steps.title` })}
        </div>
        <div className="br-add-edit-pixel-id-modal__connection-steps">
          {CONNECTION_STEPS.map(({ id, title }) => (
            <>
              <div
                className="br-add-edit-pixel-id-modal__connection-steps--content"
                key={id}
              >
                <span
                  className={classnames(
                    'br-add-edit-pixel-id-modal__connection-steps--id text-gray',
                    {
                      'br-add-edit-pixel-id-modal__connection-steps--last-id':
                        id === CONNECTION_STEPS.length && !isMetaCatalog
                    }
                  )}
                >
                  {id === CONNECTION_STEPS.length && !isMetaCatalog ? (
                    <Done />
                  ) : (
                    id
                  )}
                </span>
                <span className="br-add-edit-pixel-id-modal__connection-steps--title">
                  {title}
                </span>
              </div>
              {isMetaCatalog && id < CONNECTION_STEPS.length && <Divider />}
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default ConnectionFirstStep;
